const isOS = () => {
    return navigator.userAgent.match(/ipad|iphone/i);
};

const copyToClipboard = (text, container = document.body, className = '.frojd-copy-to-clipboard') => {
    const textArea = document.createElement('textArea');
    textArea.value = text;
    textArea.classList.add(className);

    container.appendChild(textArea);

    if (isOS()) {
        const range = document.createRange();
        range.selectNodeContents(textArea);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        textArea.setSelectionRange(0, 999999);
    } else {
        textArea.select();
    }

    const copy = document.execCommand('copy');
    container.removeChild(textArea);
    return copy;
};

export default copyToClipboard;
